var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.213,
    height: 21.213,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 21.213 21.213"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4cc0ad",
    strokeWidth: 2,
    "data-name": "Ellipse 9",
    transform: "rotate(-45 11.95 4.95)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    fill: "#4cc0ad",
    "data-name": "Rectangle 104",
    rx: 1,
    transform: "rotate(-45 23.435 -8.293)"
  })));
};
export default SvgIconSearch;